import React, { useEffect } from 'react';

import { track } from '@betterment/js-runtime';
import { Box, Icon, Text } from '@betterment/samba-react';
import { Flex, Heading, ListRowButton } from '@betterment/style-closet-react';

import { DirectDepositStepProps } from './data';
import { useTitleDispatch } from './utils';

import CopyableNumber from '../../../Shared/components/CopyableNumber';
import { Account } from '../../data';

interface Props extends DirectDepositStepProps {
  account: Account;
}

export const Overview: React.FC<React.PropsWithChildren<Props>> = ({ goToNextStep, account }) => {
  const setTitle = useTitleDispatch();
  useEffect(() => setTitle('Set up direct deposit'), [setTitle]);
  return (
    <>
      <Box
        css={{
          marginBottom: 'space.200',
        }}
      >
        <Icon name="DepositCheck" size="large" />
      </Box>
      <Flex justifyContent="left" mb="1">
        <Heading variant="primary">Set up direct deposit</Heading>
      </Flex>
      <Box
        css={{
          borderBottom: '1px solid',
          borderColor: 'grey.20',
          marginBlock: 'space.300',
          paddingBottom: 'space.300',
        }}
      >
        <Text as="p">Copy your account information below or download a form to share with your employer.</Text>
      </Box>
      <Box
        css={{
          paddingInline: {
            base: 'space.0',
            sm: 'space.200',
          },

          borderBottom: '1px solid',
          borderColor: 'grey.20',
          marginBlock: 'space.200',
          paddingBottom: 'space.200',
        }}
      >
        <CopyableNumber
          label="Routing number"
          value={account.routingNumber}
          trackingProperties={{ name: 'CopyRoutingNumber', module: 'SetupDirectDeposit' }}
          title="copy routing number"
        />
      </Box>
      <Box
        css={{
          paddingInline: {
            base: 'space.0',
            sm: 'space.200',
          },

          borderBottom: '1px solid',
          borderColor: 'grey.20',
          marginTop: 'space.200',
          paddingBottom: 'space.200',
        }}
      >
        <CopyableNumber
          label="Account number"
          value={account.accountNumber}
          trackingProperties={{ name: 'CopyAccountNumber', module: 'SetupDirectDeposit' }}
          title="copy account number"
        />
      </Box>
      <Box
        css={{
          borderBottom: '1px solid',
          borderColor: 'grey.20',
        }}
      >
        <ListRowButton
          variant="expanded"
          verticalAlign="top"
          leadingTitle="Download your pre-filled form"
          trailingIcon={<Icon name="CaretRight" size="small" />}
          onPress={() => {
            track('ElementClicked', { name: 'GetDirectDepositForm' });
            goToNextStep();
          }}
        />
      </Box>
    </>
  );
};
